import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('HardwareGiveaway').create(({ theme }) => ({
  heading: {
    fontWeight: 370,
    textTransform: 'uppercase',
    fontSize: '13px',
    lineHeight: '16px',
    color: theme.colors.text.secondary,
    margin: '0',
  },
  ambassadorRewardListWrapper: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '8px',
  },

  container: {
    width: '100%',
    height: '128px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '24px',
    alignItems: 'center',
    padding: '16px',
    borderRadius: '12px',
    border: '1px solid rgba(243, 214, 123, 1)',
  },

  img: {
    width: '138px',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  title: {
    fontFamily: 'Space Grotesk',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: theme.sizes.texts.lineHeight.xl,
    color: theme.colors.text.primary,
  },

  subTitle: {
    textWrap: 'pretty',
    fontWeight: 350,
    fontSize: '13px',
    lineHeight: '16px',
    color: theme.colors.text.secondary,
  },
}))
